import { Box } from "@mui/material";
import React from "react";
import TabPanel from "./components/tab-panel";
import PageTitle from "../../components/PageTitle";
const Dashboard = () => {
  //TODO اضافه شدن لیست پیگیری ها مطابق اکسل تو گروه
  return (
    <React.Fragment>
      <PageTitle title="داشبورد" />
      <TabPanel />
    </React.Fragment>
  );
};

export default Dashboard;
